import { WithdrawState } from '@plug-core/hooks/earn/useEarnWithdraw'
import { EarnVault } from '@plug-core/interfaces/earn'
import { formatMoney, formatNumber } from '@plug-core/utils/formatNumber'
import { Button, Heading, ListGroup } from '@ui'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { InfoRow } from './shared'

interface Props {
  vault: EarnVault
  amount: string
  receiveNative: number
  assetSymbol: string
  withdrawState: WithdrawState
  onConfirm: () => void
  onClose: () => void
}

export const EarnWithdrawReview: FC<Props> = ({
  vault,
  amount,
  receiveNative,
  assetSymbol,
  withdrawState,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation()

  // Stays busy while the sheet slides out after success; the parent leaves and shows the pill.
  const busy = withdrawState === 'loading' || withdrawState === 'success'

  const rows: { label: string; value: React.ReactNode }[] = [
    { label: t('earn.withdraw.amount'), value: formatMoney(Number(amount) || 0) },
    {
      label: t('earn.withdraw.youReceive'),
      value: formatNumber(receiveNative, assetSymbol),
    },
  ]

  return (
    <div className="m-2 flex flex-col gap-4">
      <Heading level={4} align="center">
        {t('earn.withdraw.reviewTitle')}
      </Heading>

      <ListGroup>
        {rows.map((row) => (
          <InfoRow key={row.label} label={row.label} value={row.value} />
        ))}
      </ListGroup>

      <div className="flex flex-col gap-4">
        <Button variant="primary" fullWidth loading={busy} disabled={busy} onClick={onConfirm}>
          {t('earn.withdraw.withdrawButton')}
        </Button>

        <Button variant="ghost" fullWidth disabled={busy} onClick={onClose}>
          {t('common.cancel')}
        </Button>
      </div>
    </div>
  )
}
